import { Outlet, useNavigate, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Navigator from "../Navigator.js";
import Navigator2 from "../Navigator2.js";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";

import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";

/* 
                /
                /application/personalinfo,
                /application/trustedindividual,
                /application/dependantdetails,
                /application/objectives,
                /application/incomeandexpenses,
                /application/assetsandliabilities,
                /application/currentplans,
                /application/riskinvestment,
                /application/riskcka,
                /application/affordability,
                /application/needsanalysis,
                /application/summary
                /application/products
                
              */

export default function AppLayout() {
  const pageList = [
    "/application/personalinfo",
    "/application/trustedindividual",
    "/application/dependantdetails",
    "/application/objectives",
    "/application/incomeandexpenses",
    "/application/assetsandliabilities",
    "/application/currentplans",
    "/application/riskinvestment",
    "/application/riskcka",
    "/application/needsanalysis",
    "/application/affordability",
    "/application/summary",
    "/application/products/insurance",
    "/application/products/investment",
  ];

  const pageMap = new Map();
  pageMap.set("/application/personalinfo", 0);
  pageMap.set("/application/trustedindividual", 1);
  pageMap.set("/application/dependantdetails", 2);
  pageMap.set("/application/objectives", 3);
  pageMap.set("/application/incomeandexpenses", 4);
  pageMap.set("/application/assetsandliabilities", 5);
  pageMap.set("/application/currentplans", 6);
  pageMap.set("/application/riskinvestment", 7);
  pageMap.set("/application/riskcka", 8);
  pageMap.set("/application/needsanalysis", 9);
  pageMap.set("/application/affordability", 10);
  pageMap.set("/application/summary", 11);
  pageMap.set("/application/products/insurance", 12);
  pageMap.set("/application/products/investment", 13);

  const location = useLocation();
  const navigate = useNavigate();

  function handlePrevious(e) {
    const currentIndex = pageMap.get(location.pathname);

    /*
      When current page's index lesser than total pages
      check if there's there's a next page. If there is, load it.

      When current page index == pages.size. That means current page is already on the last page.
      Don't navigate further.
    */
    if (currentIndex > 0) {
      //Get URL of previous page.
      navigate(pageList[currentIndex - 1]);
      //navigate(1);
    }
  }

  function handleNext(e) {
    let currentIndex = pageMap.get(location.pathname);
    const highestIndexPerPageCycle = pageMap.size - 1; //Eg. !4 pages --> 13 as highest cycle index

    /*
      When current page's index lesser than total pages
      check if there's there's a next page. If there is, load it.

      When current page index == pages.size. That means current page is already on the last page.
      Don't navigate further.
    */

    // let applicantCount = 1;
    let applicantCount = 2;

    //Get URL of next page.
    // if (currentIndex < pageMap.size - 1) {
    //   navigate(pageList[currentIndex + 1]);
    // }

    if (currentIndex < pageMap.size * applicantCount - 1) {
      //MOVE PAGE: When current Index is under the  1cycle (Eg. Index: 0- 13)

      if (currentIndex < pageMap.size - 1) {
        navigate(pageList[currentIndex + 1]);
      } else {
        currentIndex = currentIndex % highestIndexPerPageCycle;
        navigate(pageList[(currentIndex % highestIndexPerPageCycle) + 1]);
      }

      //MOVE PAGE: When current Index is above 1st cycle (Eg. Index: 14 - 27)
    }
  }

  function handleSubmit(e) {
    console.log("Submitted");
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        // border: "1px solid red",
      }}
    >
      {/* LEFT - SIDEBAR */}
      <Grid container spacing={2} columns={12}>
        <Grid size={Number(2.8)}>
          {/* <Card variant="outlined" sx={{  height: '100%', flexGrow: 1 }}> */}
          <Paper
            elevation={5}
            sx={{ minWidth: "255px", minHeight: "1100px", width: "100%" }}
          >
            {/* <Navigator /> */}
            <Navigator2 />
          </Paper>

          {/* </Card> */}
        </Grid>

        {/* RIGHT - OUTLET AND PAGE NAVIGATOR */}
        <Grid size={Number(9.2)}>
          <Grid container spacing={2} rows={2} columns={12}>
            {/*PAGE OUTLET */}
            <Grid spacing={2} size={12}>
              {/* <Card variant="outlined" sx={{ flexGrow: 1 }}> */}
              <Paper elevation={5} sx={{ minHeight: "1034px", px: 2.5, py: 2 }}>
                <Outlet />
              </Paper>
              {/* </Card> */}
            </Grid>

            {/*PAGE NAVIGATOR */}
            {/* <Grid spacing={2} size={12}>
              <Paper elevation={5} sx={{ minHeight: "50px", pt: 1 }}>
                <Stack spacing={2} direction="row" justifyContent="center">
                  <Button
                    variant="contained"
                    sx={{ width: "100px" }}
                    disabled={false}
                    onClick={handlePrevious}
                  >
                    Previous
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ width: "100px" }}
                    disabled={false}
                    // onClick={handleNext}
                  >
                    Next
                  </Button>
                </Stack>
              </Paper>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
